import { useState, useContext, useEffect } from "react"

import { Field, useFormikContext } from "formik"
import _ from "lodash"

import { Dropdown } from "primereact/dropdown"
import { FormContext } from "../../context/formContext"

import styles from "../../styles/Form.module.css"

export default function TypeDropDownList({ field, block, index }) {
  const [optionList, setOptionList] = useState([])
  const formik = useFormikContext()
  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const value_selected = formik?.getFieldProps(conditionalFieldKey)
    const options = _.map(groupOptions[value_selected.value], (option) => {
      return {
        label: _.trim(option.groupItem),
        value: _.trim(option.groupItem),
      }
    })
    setOptionList(options)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik])

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const parseStringToObj = (string) => {
    try {
      return JSON.parse(string)
    } catch {
      return {}
    }
  }
  const { field_conditional, field_options } = field
  const grouping = _.map(field_options, (field_option) => {
    const option = _.split(field_option.value, "|")
    return { groupName: _.trim(option[0]), groupItem: _.trim(option[1]) }
  })
  const groups = _.chain(grouping)
    .groupBy("groupName")
    .map((groupName, groupItem) => ({ [groupItem]: groupName }))
    .value()
  const groupOptions = _.assign({}, ...groups)
  const conditionalFieldObj =
    !_.isEmpty(field_conditional) && parseStringToObj(field_conditional)
  const getConditionalFieldKey = () => {
    const keyList = Object.keys(conditionalFieldObj)
    return keyList[0]
  }
  const conditionalFieldKey = getConditionalFieldKey()

  return (
    <div
      className={styles.field}
      style={{
        order: index,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => (
            <>
              <Dropdown
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                options={optionList}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
